import axios from "axios";
import Cookies from "js-cookie";
import { EventSourcePolyfill } from 'event-source-polyfill';
import "vant/lib/index.css";
import { showConfirmDialog, Popup, Loading ,showToast} from "vant";
// axios.defaults.baseURL = process.env.VUE_APP_BASE_API;
axios.defaults.baseURL = window.location.href.includes(".medsci.cn")
  ? "https://www.medsci.cn/"
  : "https://portal-test.medon.com.cn/";
axios.interceptors.request.use(
  (config) => {
    if (Cookies.get("userInfo")) {
      config.headers["Authorization"] = encodeURIComponent(
        "userInfo=" + Cookies.get("userInfo")
      );
    }
    return config;
  },
  (error) => {
    Promise.reject(error);
  }
);

export default {
  name: "common",
  components: { Popup, Loading },
  data() {
    return {
      isIOS:false,
      fnlList:[],
      recomendList: [],
      topKeywords: [],
      isLightTheme: false,
      contextIdIndex: -1,
      hoverIndex: -1,
      activeIndex: -1,
      isImgVisible: false,
      imgTop: 0,
      titleText: " 你好，我是&nbsp梅斯AI小智",
      isOtherTips: false, //是否显示提示
      otherTipsList: [], //提示列表
      isLeftNav: true, //显示左边栏
      message: "",
      messageList: [], //会话列表
      contextDisable: false,
      messageTp: "",
      userInfo: {},
      // defaultAvatar: "https://www.medsci.cn/v1.0.0/img/user_icon.png",
      defaultAvatar:require("./images/avat.png"),
      userName: "",
      userAgent: this.getRandomUser(),
      avatar: require("./images/avat.png"),
      logList: [], //左侧历史记录列表
      showMenu: false,
      chatTopic: '',
      showTxt: "",
      isShow: true,
      chatTemplateList: [],
      filterList: [],
      answer: '',
      feedbackHref:'',
      eventSource: undefined,
      // valueList: [
      //   { id: 1, title: "用药咨询", text: "AI可以代替哪些临床医生的日常" },
      //   {
      //     id: 2,
      //     title: "用药咨询",
      //     text: "AI可以代替哪些临床医生的日常... AI是如何识别诊断医学影像的AI是如何识别诊断医学影像的",
      //   },
      //   { id: 3, title: "用药咨询", text: "疼痛有哪些常用药" },
      //   {
      //     id: 4,
      //     title: "用药咨询",
      //     text: "写一篇SCI论文大纲。写一篇白血病科普文AI可以代替哪些临床医生的日常。写一篇SCI论文大纲。写一篇白血病科普文AI可以代替哪些临床医生的日常。写一篇白血病科普文AI可以代替哪些临床医生的日常。写一篇白血病科普文AI可以代替哪些临床医生的日常写一篇白血病科普文AI可以代替哪些临床医生的日常。写一篇白血病科普文AI可以代替哪些临床医生的日常",
      //   },
      //   { id: 5, title: "用药咨询", text: "AI是如何识别诊断医学影像的" },
      //   { id: 6, title: "用药咨询", text: "抑郁症的临床治疗" },
      // ],
      textareaHeight: "40px",
    };
  },
  computed: {
    highlightText() {
      if(this.isLightTheme){
        return this.titleText.replace(
          /梅斯AI小智/g,
          "<span style='color:#4892E7'>梅斯AI小智</span>"
        );
      }else{
        // 将字符串中某些设置为蓝色
      return this.titleText.replace(
        /梅斯AI小智/g,
        "<span style='color:#79B7FF'>梅斯AI小智</span>"
      );
      }
      
    },
    currentTheme() {
      return this.isLightTheme ? "light-theme" : "dark-theme";
    },
    
  },
  created() {
    if(window.location.href.includes('medon.com.cn')){
      this.feedbackHref='https://portal-test.medon.com.cn/message/add_msg.do'
    }else{
      this.feedbackHref='https://www.medsci.cn/message/add_msg.do'
    }
    this.getChatTemplate();
    this.getAiKeywordTop();
    this.chatMessage();
  },
  mounted() {
    // this.getAnswer()
    this.initLogin();
    this.listMessage();
      // 判断是否是iOS环境
      const userAgent = navigator.userAgent;
      this.isIOS = /iPad|iPhone|iPod/.test(userAgent) && !window.MSStream;
  },
  methods: {
    // 打字机效果
    getAnswer(){
      this.chatTopics= this.chatTopic.replaceAll(/\[|\]/g, '').replaceAll("<br/>", '')
      this.messageTps= this.messageTp.replaceAll(/\[|\]/g, '').replaceAll("<br/>", '')
      this.messageFirst = this.messageList[0].message.replaceAll(/\[|\]/g, '').replaceAll("<br/>", '')
      var _this = this
      const scrollbar = document.getElementById("scrollbar");
      // SSE的API在EventSource对象上
      // 可以使用 if('EventSource' in window) 判断浏览器是否支持SSE
      // 建立SSE连接，直接如下创建EventSource实例，支持跨越、
      // let url = window.location.href.includes('.medsci.cn')?'https://mschat.medsci.cn/bioon/course/api/medsciAiLog/saveAiChat':'https://mschat.medon.com.cn/bioon/course/api/medsciAiLog/saveAiChat';
      let url = window.location.href.includes('.medsci.cn')?'https://mschat.medsci.cn/bioon/course/api/medsciAiLog/v1/saveAiChat':'https://mschat.medon.com.cn/bioon/course/api/medsciAiLog/v1/saveAiChat';
      let data = `?chatType=1&chatTopic=${this.chatTopics || this.messageFirst}&message=${this.messageTps}&chatName=${this.userName}`
      _this.eventSource = new EventSourcePolyfill(url+data,{
        // heartbeatTimeout: 60000,
          // headers: {
          //   Authorization: encodeURIComponent("userInfo="+Cookies.get("userInfo"))
          // },
      });

      // EventSource.readyState代表连接状态，有以下三种情况
      // 0 —> 连接还未建立，或者正在断线重连
      // 1 -> 连接已建立，可以接受数据
      // 2 -> 连接已关闭或请求错误


      // 连接创建成功的回调事件
      _this.eventSource.addEventListener("open", function(event) {
        if(event.status == 429) {
          const errorlist = {
            chatName: "medsciAI",
            conversationId: 123,
            chatType: 2,
            message: "网络异常！休息下，请稍后再试！",
          };
          _this.messageList = _this.messageList.filter(
            (item) => item.conversationId !== 111
          );
          _this.messageList.push(errorlist);
          _this.contextDisable = false;
          // 滚动滚动条到底部
          scrollbar.scrollTop = scrollbar.scrollHeight;
          _this.eventSource.close();
        }
        console.log('open successfully')
      })

      // 连接创建失败的回调事件
      _this.eventSource.addEventListener("error", function(err) {
        // 类似的返回信息验证，这里是实例
        // err && err.status === 401 && console.log('not authorized')
        const errorlist = {
          chatName: "medsciAI",
          // time: this.getNowTime(),
          conversationId: 123,
          chatType: 2,
          message: "访问太火爆了！休息下，请稍后再试！",
        };
        _this.messageList = _this.messageList.filter(
          (item) => item.conversationId !== 111
        );
        _this.messageList.push(errorlist);
        _this.contextDisable = false;
        // 滚动滚动条到底部
        scrollbar.scrollTop = scrollbar.scrollHeight;
        console.log(err);
        _this.eventSource.close();
      })
      
      // 默认相应message事件
      _this.eventSource.addEventListener("message", function(event) {
        event.data = event.data.replace("medsci_data_start",'')
        event.data = event.data.replace("medsci_data_end",'')
        console.log(event)
        if(event.data === 'medsci_start') {
          _this.answer = ''
          _this.messageList = _this.messageList.filter(
            (item) => item.conversationId !== 111
          );
          let data = {
            message: _this.answer,
            resAi: "medsciAI"
          }
          _this.messageList.push(data);
          // 首次发送推送到右侧tab
          if(!_this.chatTopic) {
            _this.listMessage()
          }
          // 滚动滚动条到底部
          scrollbar.scrollTop = scrollbar.scrollHeight;
        }else if(event.data === 'medsci_end') {
          _this.eventSource.close();
          _this.contextDisable = false;
        }else if(event.data === 'medsci_login') {
          _this.initLogin();
          _this.answer = '请登录账号'
          _this.messageList[_this.messageList.length-1].message = _this.answer
          _this.eventSource.close();
          _this.contextDisable = false;
        }else {
          _this.$nextTick(()=>{
            event.data = event.data.replace(/\\n/g,"<br/>");
            event.data = event.data.replace(/\\r/g,"<br/>");
            _this.answer += String(event.data)
            _this.messageList[_this.messageList.length-1].message = _this.answer
            scrollbar.scrollTop = scrollbar.scrollHeight;
          })
        }
      })

      // 关闭连接  eventSource.close();
    },
    adjustTextareaHeight() {
      var textarea =this.$refs.myTextarea;
      textarea.style.height="auto";
      if(textarea.style.height>=60){
        textarea.style.height = 60
      }else{
        textarea.style.height = textarea.scrollHeight + "px"

      }
    },
    getAiKeywordTop() {
      axios
        .post("/medsciAiKeywordTop/queryAiKeywordTop", {
          pageIndex: 1,
          pageSize: 5,
        })
        .then((res) => {
          if (res.status == 200) {
            this.topKeywords = res.data.data;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getChatTemplate() {
      axios
        .post("/medsciAiTemplate/queryAiTemplate", {
          pageIndex: 1,
          pageSize: 20,
        })
        .then((res) => {
          if (res.status == 200) {
            let responseData = res.data.data;
            responseData.forEach((item) => {
              if (JSON.parse(item.chatTags)[0]) {
                let chatTag = JSON.parse(item.chatTags)[0];
                item.tagName =
                  chatTag.tagName.length > 5
                    ? chatTag.tagName.substring(0, 5) + "..."
                    : chatTag.tagName;
              }
            });
            this.chatTemplateList = responseData;
            if (this.getFilteredItems().length <= 6) {
              this.filterList = this.getFilteredItems();
            } else {
              this.filterList = this.getFilteredItems().slice(0, 6);
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.showMenu = false;
        });
    },

   getFilteredItems() {
         return this.chatTemplateList.filter((item) => item.approvalStatus === 1).map(item => {
          // 梅斯,-t
          const variableList = item.chatVariable.split(',')
          // console.log('variableList: ', variableList);
          item.chatFormatTemplate = item.chatTemplate;
          variableList.forEach(variable => {
           item.chatFormatTemplate = item.chatFormatTemplate.replaceAll(`[${variable}]`, `<span style="color:#79B7FF">[${variable}]</span>`)
          })
          return item;
         });
        },
    stripHtmlTags(html) {
      return html.replace(/<[^>]*>/g, "");
    },
    onMouseover(index) {
      this.hoverIndex = index;
    },
    onMouseout() {
      this.hoverIndex = -1;
    },
    //获取选择的内容按下标获取
    setInput(chatTags) {
        axios
        .post("/medsciAiTemplate/queryAiTemplate", {
          chatTags:chatTags,
          pageIndex: 1,
          pageSize: 20,
        }).then(res=>{
          if(res.data.status == 200){
            this.message = res.data.data[0].chatTemplate
            this.isOtherTips=false
          }else if (res.data.status == 204) {
           showToast('暂无审核通过的数据');
           }
      }) .catch((error) => {
        console.log(error);
      });
    },
    chatMessage() {
      if (this.message == "/") {
        this.isOtherTips = true;
      } else {
        this.isOtherTips = false;
      }
    },
   
    getDiffDay(date_1, date_2) {
      if(this.isIOS){
        date_1=date_1.replace(/-/g, '/')
        date_2=date_2.replace(/-/g, '/')
      }
      // 计算两个日期之间的差值
      let totalDays, diffDate;
      let myDate_1 = Date.parse(date_1);
      let myDate_2 = Date.parse(date_2);
      // 将两个日期都转换为毫秒格式，然后做差
      diffDate = Math.abs(myDate_1 - myDate_2); // 取相差毫秒数的绝对值
      totalDays = Math.floor(diffDate / (1000 * 3600 * 24)); // 向下取整
      return totalDays; // 相差的天数
    },
    // 初始化登录
    initLogin() {
      // 本地调试用默认账号
      if (window.location.href.includes("localhost")) {
        this.userInfo = {
          getRoleLoginResponses: [
            { identityFlag: 0, roleId: 8, roleName: "前台角色" },
          ],
          mobile: "13816433085",
          plaintextUserId: 6809509,
          projectCode: "MSYX",
          projectId: 1,
          projectName: "梅斯医学",
          projectType: 0,
          projectUserStatus: 1,
          realName: "Jeffrey",
          token: {
            accessToken:
              "eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiLmn4_kvbPmrKIiLCJ1c2VySWQiOiI2ODA5NTA5IiwidXNlcm5hbWUiOiLmn4_kvbPmrKIiLCJleHAiOjIzMTM5OTY3NTd9.qiKqplmhUwQBI7CPJDiakl98olVEwub9CfTmAMtnR6NLPuZuS5b1A4J_SHZHD5rBWig7djufEjXIN518Rh8gDlFzZypTlb0bT1r_LRfYOSrQm1TAaAHCavaS4NWYoZNhGQJoVPlBYGWZIF4hx51E7RGU7CFoTsPo1q6n0g_jzn4",
            accessTokenExpireTime: 630720000,
            refreshToken:
              "eyJhbGciOiJSUzI1NiJ9.eyJzdWIiOiLmn4_kvbPmrKIiLCJ1c2VySWQiOiI2ODA5NTA5IiwidXNlcm5hbWUiOiLmn4_kvbPmrKIiLCJleHAiOjE2ODMzNjMxNTd9.E2C-cQbG4qLtVFU_avGqQniEP76hVehOAIVTJ49emv0vnPVLAjycnUbuxG37zZo6K1Vd0rQrgt_zBbrwiULX14XK9tZydYeQoQ7P7gp0wrNt6thNEf5Hm4aKLTjwXRVyvJbsypaAIsQtYgo7Ro1BQPfmBzezm1dUWyJOr45mM8M",
          },
          userId: "05d56809509",
          userName: "柏佳欢",
          userStatus: 1,
        };
        this.userName = this.userInfo?.userName || this.userAgent;
        this.avatar = this.userInfo?.avatar || this.defaultAvatar;
        return;
      }
      if (Cookies.get("userInfo")) {
        this.userInfo = JSON.parse(Cookies.get("userInfo"));
        this.userName = this.userInfo?.userName || this.userAgent;
        if(this.userInfo?.avatar){
          if(this.userInfo?.avatar !== "/v1.0.0/img/user_icon.png"){
            this.avatar = this.userInfo?.avatar
          }else{
            this.avatar = this.defaultAvatar
          }
        }else{
          this.avatar = this.defaultAvatar
        }
      } else {
        window.addLoginDom();
      }
    },
    // 生成/获取随机标识
    getRandomUser() {
      let info = `randomUser${Date.now() + Math.ceil(Math.random() * 99999)}`;
      if (!window.localStorage.getItem("randomUser")) {
        window.localStorage.setItem("randomUser", info);
      }
      let user = window.localStorage.getItem("randomUser");
      return user;
    },
    // 开始新对话
    newTalk() {
      this.messageList = [];
      this.chatTopic = '';
      this.listMessage();
      (this.showMenu = false), (this.isShow = true),(this.contextDisable = false);
      if(this.eventSource){
        this.eventSource.close();
      }
      this.answer = ''
    },
    hidePage() {
      this.isShow = false;
    },
    closeMenuPc() {
      this.isLeftNav = false;
    },
    openMenuPc() {
      this.isLeftNav = true;
    },
    // 获取左侧会话列表
    listMessage() {
      axios
        .post("/medsciAiChat/getAiTopicLog", {
          chatName: this.userName, //聊天人昵称
          pageIndex: 1,
          pageSize: 20,
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.logList = [];
            let nowTime = this.getNowTime();

            let templogList = response.data.data;
            if (!templogList) {
              //处理空状态
              return;
            }

            let logList = templogList.map((item) => {
              item.chatTopic =  decodeURIComponent(item.chatTopic)
              return {
                ...item,
                daySubVal: this.getDiffDay(item.createdTime, this.getNowTime()),
                yearSubVal: Number(
                  nowTime.substring(0, 4) - item.createdTime.substring(0, 4)
                ),
              };
            });
            logList = JSON.parse(JSON.stringify(logList));
            for (var j = 0; j < logList.length; j++) {
              logList[j].createdTime = this.getDaySubFn(
                logList[j].daySubVal,
                logList[j].yearSubVal,
                logList[j].createdTime
              );
            }
            let tempCreatedTime = "";
            for (var i = 0; i < logList.length; i++) {
              if (i == 0) {
                tempCreatedTime = logList[i].createdTime;
                continue;
              } else {
                if (i > 0) {
                  if (logList[i].createdTime == tempCreatedTime) {
                    logList[i].createdTime = "";
                  } else {
                    tempCreatedTime = logList[i].createdTime;
                  }
                }
              }
            }
            this.logList = logList;
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    getDaySubFn(daySubVal, yearSubVal, createdTime) {
      if (yearSubVal > 1) {
        return createdTime.subString(0, 10);
      } else if (daySubVal >= 30) {
        return "30天前";
      } else if (daySubVal >= 7) {
        return "一周前";
      } else if (daySubVal >= 1) {
        return "昨天";
      } else {
        return "今天";
      }
    },
    // 获取历史会话记录
    getLog(id, name, index) {
      this.contextIdIndex = index;
      this.logList.forEach((item) => {
        item.isActive = false;
        if (item.conversationId == id) {
          item.isActive = true;
        }
      });
      this.chatTopic = name;
      axios
        .post("/medsciAiChat/getAiLog", {
          chatName: this.userName, //聊天人昵称
          pageIndex: 1,
          pageSize: 20,
          conversationId: id,
        })
        .then((response) => {
          if (response.data.status == 200) {
            this.messageList = [];
            let data = response.data.data;
            data.forEach((item) => {
              item.dialogues[0].message = item.dialogues[0].message.replace(
                /\\n/g,
                "<br/>"
              );
              item.dialogues[0].message =  decodeURIComponent(item.dialogues[0].message)
              this.messageList.push(item.dialogues[0]);
              item.dialogues[1].message = item.dialogues[1].message.replace(
                /\\n/g,
                "<br/>"
              );
              item.dialogues[1].message =  decodeURIComponent(item.dialogues[1].message)
              this.messageList.push(item.dialogues[1]);
            });
          }
          this.showMenu = false;
        })
        .catch((error) => {
          console.log(error);
          this.showMenu = false;
        });
    },
    // 发送逻辑
    sendMessage() {
      const scrollbar = document.getElementById("scrollbar");
      if (this.message) {
        this.contextDisable = true;
        const userlist = [
          {
            chatName: this.userName,
            chatType: 1,
            message: this.message.replace(/\n/g, "<br/>"),
          },
          {
            chatName: "medsciAI",
            conversationId: 111,
            message: "loading",
            chatType: 2,
            // time: this.getNowTime(),
            // message: this.message
          },
        ];
        this.messageList.push(...userlist);
        // 滚动滚动条到底部
        this.$nextTick(() => {
          scrollbar.scrollTop = scrollbar.scrollHeight;
        });
        this.messageTp = this.message;
        this.message = ""; // 清空用户输入
        this.getAnswer()
      }
    },
    reloadMessage() {
      this.message = this.messageTp;
      this.messageList.splice(-2);
      this.sendMessage();
    },
    // 移动端打开侧边栏
    openMenu() {
      this.showMenu = true;
    },
    // 退出登录
    logout() {
      showConfirmDialog({
        title: "提示",
        message: "是否退出登录？",
      })
        .then(() => {
          let href;
          if (window.location.href.includes(".medsci.cn")) {
            href = "https://www.medsci.cn";
          } else {
            href = "https://portal-test.medon.com.cn";
          }
          window.location.href =
            href + "/sso_logout?redirectUrl=" + window.location.href;
        })
        .catch(() => {});
    },
    getNowTime() {
      // 获取当前时间
      const now = new Date();
      // 格式化时间
      const year = now.getFullYear();
      const month = now.getMonth() + 1;
      const date = now.getDate();
      // const hours = now.getHours();
      // const minutes = now.getMinutes();
      // const seconds = now.getSeconds();
      // 输出时间
      return `${year}-${month}-${date} 00:00:00`;
    },
    editBtn(text) {
      this.message = text;
    },
  },
};
